<lng-character-details
  *ngIf="activeCharacter$ | async as character; else wordRef"
  [language]="(word$ | async)?.language"
  [character]="character"></lng-character-details>
<ng-template #wordRef>
  <lng-word-details></lng-word-details>
</ng-template>
